<template>
    <card class="card-pricing bg-gradient-default border-0 text-center mb-4"
        header-classes="bg-transparent"
        body-classes="px-lg-7"
        footer-classes="bg-transparent"
    >

        <div class="display-3 text-white mb-3">
            <span class="text-muted d-inline">{{ registration.cohort.name }}</span>
            <span class="text-muted d-inline"> / {{ registration.degree.name }}</span>
            <span class="d-inline text-muted">/</span>
            <span class="d-inline">{{ simulation.name }}</span>
        </div>

    </card>
</template>

<script>
    export default {

        props: {
            registration: {
                type: Object,
                required: true
            },

            simulation: {
                type: Object,
                required: true
            },
        },
    }
</script>
